import React from "react";

import Login from "./components/Login";
import Signup from "./components/Signup";
import Confirm from "./components/Confirm";
import Forgot from "./components/Forgot";
import ConfirmForgot from "./components/ConfirmForgot";
import Success from "./components/Success";
import Confirmed from "./components/Confirmed";
import ConfirmationHelp from "../ConfirmationHelp";
import AuthContext from "../../contexts/AuthContext";

const Auth = ({ config, orgId, defaultTab, initialPage }) => {
  const { setEmail } = React.useContext(AuthContext);
  const [page, setPage] = React.useState(initialPage || "login");
  const [pw, setPw] = React.useState(null);
  const [autoCode, setAutoCode] = React.useState(null);
  const [next, setNext] = React.useState(null);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const confirm = urlParams.get("confirm");
    const code = urlParams.get("code");
    const emailParam = urlParams.get("email");
    const nextParam = urlParams.get("next");

    // Magic-link confirmation: /confirm?email=&code=&next= auto-fills and
    // submits the confirm screen.
    if (code && emailParam) {
      if (emailParam) setEmail(emailParam.toLowerCase());
      if (nextParam) setNext(nextParam);
      setAutoCode(code);
      setPage("confirm");
    } else if (confirm === "true") {
      setPage("confirm");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (page) {
    case "login":
      return <Login setPage={(p) => setPage(p)} config={config} orgId={orgId} defaultTab={defaultTab}/>;
    case "signup":
      return <Signup setPage={(p) => setPage(p)} setPw={(val) => setPw(val)} config={config}/>;
    case "confirm":
      return <Confirm setPage={(p) => setPage(p)} pw={pw} autoCode={autoCode} next={next} />;
    case "forgot":
      return <Forgot setPage={(p) => setPage(p)} />;
    case "confirm-forgot":
      return <ConfirmForgot setPage={(p) => setPage(p)} />;
    case "confirmed":
      return <Confirmed setPage={(p) => setPage(p)} pw={pw} />;
    case "success":
      return <Success setPage={(p) => setPage(p)} />;
    case "troubleshoot":
      return <ConfirmationHelp setPage={(p) => setPage(p)} />;

    default:
      return <Login config={config} orgId={orgId}/>;
  }
};

export default Auth;
